import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPlans } from '../../services/subscriptionService';

export const fetchPlans = createAsyncThunk(
  'plans/fetchPlans',
  async (options = {}, { rejectWithValue }) => {
    try {
      const plans = await getPlans(options);
      return plans;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Failed to load plans';
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  items: [],
  status: 'idle',
  error: null,
  fetchedAt: null,
};

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    clearPlansError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
        state.fetchedAt = Date.now();
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to load plans';
      });
  },
});

export const { clearPlansError } = plansSlice.actions;
export default plansSlice.reducer;
